import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from "react";
import api, {
  GetOrganizationResponse,
  Organization,
} from "../../../hooks/api";
import { useAxios } from "../../../hooks/axios";

interface IOrganizationContext {
  organization: Organization | undefined;
  setOrganization: Dispatch<SetStateAction<Organization | undefined>>;
  pendingInvites: GetOrganizationResponse["pending_invites"] | undefined;
  setPendingInvites: Dispatch<
    SetStateAction<GetOrganizationResponse["pending_invites"] | undefined>
  >;
  loading: boolean;
  error: unknown | undefined;
}

export const OrganizationContext = createContext<IOrganizationContext>(
  {} as IOrganizationContext
);

export const OrganizationProvider = (props: {
  children: ReactNode | ReactNode[];
}) => {
  const [organization, setOrganization] = useState<Organization>();
  const [pendingInvites, setPendingInvites] = useState<string[]>();

  const axios = useAxios();
  const getOrganization = api.useGetOrganization(axios);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    (async () => {
      setError(undefined);
      setLoading(true);
      try {
        const response = await getOrganization();
        setOrganization(response.data.organization);
        setPendingInvites(response.data.pending_invites);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [getOrganization]);

  return (
    <OrganizationContext.Provider
      value={{
        organization,
        setOrganization,
        pendingInvites,
        setPendingInvites,
        loading,
        error,
      }}
    >
      {props.children}
    </OrganizationContext.Provider>
  );
};
